import { getEvents } from "../../../../../actions/Utilities/EmailWorkFlow";
import { useQuery } from "react-query";

export default function useOperations() {
  return useQuery("GetEvents", getEvents, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}
